import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { EnumValues } from '@card-software/library';
import { KnittingOrderSearchCommand, KnittingOrderStatus } from '@app/models/production/knitting-order';

interface KnittingOrderFilterForm {
  knittingOrderNumber: FormControl<string | null>;
  statuses: FormControl<number[] | null>;
}

@Component({
  selector: 'app-knitting-order-filter',
  templateUrl: './knitting-order-filter.component.html',
  styleUrl: './knitting-order-filter.component.scss',
})
export class KnittingOrderFilterComponent implements OnChanges {
  @Output() filterChange = new EventEmitter<KnittingOrderSearchCommand>();
  @Input() statusOptions: EnumValues = {};
  filterForm: FormGroup<KnittingOrderFilterForm>;

  constructor() {
    this.filterForm = new FormGroup<KnittingOrderFilterForm>({
      knittingOrderNumber: new FormControl<string | null>(null),
      statuses: new FormControl<number[] | null>(null),
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['statusOptions'] && this.statusOptions) {
      // Set default statuses to all except "Voided"
      const defaultStatuses = Object.keys(this.statusOptions)
        .filter((key) => {
          return key !== KnittingOrderStatus[KnittingOrderStatus.Voided];
        })
        .map((key) => Number(key));

      this.filterForm.patchValue({
        statuses: defaultStatuses,
      });
    }
  }

  applyFilters(): void {
    const formValue = this.filterForm.value;
    const command: KnittingOrderSearchCommand = {
      knittingOrderNumber: formValue.knittingOrderNumber || undefined,
      statuses: formValue.statuses || undefined,
    };
    this.filterChange.emit(command);
  }

  resetFilters(): void {
    this.filterForm.reset();
    this.applyFilters();
  }

  // Helper to convert status enum to array for multi-select dropdown
  get statusOptionsArray(): { label: string; value: number }[] {
    return Object.entries(this.statusOptions).map(([key, value]) => ({
      label: value as string,
      value: Number(key),
    }));
  }
}
